import React from 'react';
import AccountBox from "../../components/auth/accountBox/index";
import { Box } from '@mui/material';
import styled from "styled-components";

const AppContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

function LoginForm() {

    return (
        <AppContainer>
            <AccountBox />
        </AppContainer>
    );
}

export default LoginForm;
